"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lossRecordStatusColor = exports.colors = exports.Colors = void 0;

var _colorNames = _interopRequireDefault(require("./colorNames"));

var _constants = require("./constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Colors = /*#__PURE__*/function () {
  function Colors(_ref) {
    var colorNames = _ref.colorNames;

    _classCallCheck(this, Colors);

    var color, rgb, hsl;
    this.names = colorNames;

    for (var i = 0; i < this.names.length; i++) {
      color = '#' + this.names[i][0];
      rgb = this.rgb(color);
      hsl = this.hsl(color);
      this.names[i].push(rgb[0], rgb[1], rgb[2], hsl[0], hsl[1], hsl[2]);
    }
  }

  _createClass(Colors, [{
    key: "name",
    value: function name(hex) {
      var color = hex.toUpperCase();
      if (color.length < 3 || color.length > 7) return ['#000000', 'Invalid Color: ' + hex, false];
      if (color.length % 3 == 0) color = '#' + color;
      if (color.length == 4) color = '#' + color.substr(1, 1) + color.substr(1, 1) + color.substr(2, 1) + color.substr(2, 1) + color.substr(3, 1) + color.substr(3, 1);
      if (!color.match(/#[0-9a-f]{6,6}/gi)) return ['#000000', 'Invalid Color: ' + hex, false];

      var _this$rgb = this.rgb(color),
          _this$rgb2 = _slicedToArray(_this$rgb, 3),
          r = _this$rgb2[0],
          g = _this$rgb2[1],
          b = _this$rgb2[2];

      var _this$hsl = this.hsl(color),
          _this$hsl2 = _slicedToArray(_this$hsl, 3),
          h = _this$hsl2[0],
          s = _this$hsl2[1],
          l = _this$hsl2[2];

      var ndf1 = 0,
          ndf2 = 0,
          ndf = 0;
      var cl = -1,
          df = -1;

      for (var i = 0; i < this.names.length; i++) {
        if (color == '#' + this.names[i][0]) return ['#' + this.names[i][0], this.names[i][1], true];
        ndf1 = Math.pow(r - this.names[i][2], 2) + Math.pow(g - this.names[i][3], 2) + Math.pow(b - this.names[i][4], 2);
        ndf2 = Math.pow(h - this.names[i][5], 2) + Math.pow(s - this.names[i][6], 2) + Math.pow(l - this.names[i][7], 2);
        ndf = ndf1 + ndf2 * 2;

        if (df < 0 || df > ndf) {
          df = ndf;
          cl = i;
        }
      }

      return cl < 0 ? ['#000000', 'Invalid Color: ' + color, false] : ['#' + this.names[cl][0], this.names[cl][1], false];
    } // adopted from: Farbtastic 1.2
    // http://acko.net/dev/farbtastic

  }, {
    key: "hsl",
    value: function hsl(color) {
      var r = parseInt('0x' + color.substring(1, 3)) / 255,
          g = parseInt('0x' + color.substring(3, 5)) / 255,
          b = parseInt('0x' + color.substring(5, 7)) / 255;
      var min = Math.min(r, Math.min(g, b)),
          max = Math.max(r, Math.max(g, b)),
          h = 0,
          s = 0;
      var delta = max - min;
      var l = (min + max) / 2;
      s = 0;
      if (l > 0 && l < 1) s = delta / (l < 0.5 ? 2 * l : 2 - 2 * l);
      h = 0;

      if (delta > 0) {
        if (max == r && max != g) h += (g - b) / delta;
        if (max == g && max != b) h += 2 + (b - r) / delta;
        if (max == b && max != r) h += 4 + (r - g) / delta;
        h /= 6;
      }

      return [parseInt(h * 255), parseInt(s * 255), parseInt(l * 255)];
    } // adopted from: Farbtastic 1.2
    // http://acko.net/dev/farbtastic

  }, {
    key: "rgb",
    value: function rgb(color) {
      return [parseInt('0x' + color.substring(1, 3)), parseInt('0x' + color.substring(3, 5)), parseInt('0x' + color.substring(5, 7))];
    }
  }]);

  return Colors;
}();

exports.Colors = Colors;
var colors = new Colors({
  colorNames: _colorNames["default"]
});
exports.colors = colors;

var lossRecordStatusColor = function lossRecordStatusColor(lossRecordStatus, color) {
  var _map;

  var map = (_map = {}, _defineProperty(_map, _constants.LossRecordStatusEnum.SPILLAGE, {
    mainColor: 'rgba(254, 70, 83, 1)',
    inactiveColor: 'rgba(255, 255, 255, 1)',
    hoverColor: 'rgba(254, 70, 83, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.BREAKAGE, {
    mainColor: 'rgba(250, 207, 158, 1)',
    inactiveColor: 'rgba(221, 221, 221, 1)',
    hoverColor: 'rgba(250, 207, 158, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.RETURN, {
    mainColor: 'rgba(253, 161, 136, 1)',
    inactiveColor: 'rgba(187, 187, 187, 1)',
    hoverColor: 'rgba(253, 161, 136, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.OTHER, {
    mainColor: 'rgba(210, 202, 154, 1)',
    inactiveColor: 'rgba(136, 136, 136, 1)',
    hoverColor: 'rgba(210, 202, 154, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.MISSING, {
    mainColor: 'rgba(153, 178, 137, 1)',
    inactiveColor: 'rgba(102, 102, 102, 1)',
    hoverColor: 'rgba(153, 178, 137, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.SPOILING, {
    mainColor: 'rgba(234, 37, 159, 1)',
    inactiveColor: 'rgba(68, 68, 68, 1)',
    hoverColor: 'rgba(234, 37, 159, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.PRODUCTION_WASTE, {
    mainColor: 'rgba(227, 225, 43, 1)',
    inactiveColor: 'rgba(34, 34, 34, 1)',
    hoverColor: 'rgba(227, 225, 43, 0.8)'
  }), _defineProperty(_map, _constants.LossRecordStatusEnum.EXPIRATION, {
    mainColor: 'rgba(166, 55, 179, 1)',
    inactiveColor: 'rgba(0, 0, 0, 1)',
    hoverColor: 'rgba(166, 55, 179, 0.8)'
  }), _map);
  return map[lossRecordStatus][color];
};

exports.lossRecordStatusColor = lossRecordStatusColor;